// extracted by mini-css-extract-plugin
export var actionButton = "_ws-2";
export var card = "_ws-0";
export var disambiguationList = "_ws-3";
export var errorCard = "_ws-4";
export var row = "_ws-1";